import { z } from 'zod';

import type { ComponentQuery } from '../types/Search';

export const ProfileAnalyticsQuery = z.object({
    from: z.coerce.date(),
    to: z.coerce.date(),
});

export type ProfileAnalyticsQuery = z.infer<typeof ProfileAnalyticsQuery>;

export type ProfileAnalyticsEvent = {
    _id: string;
    name: string;
    data: {
        position?: number;
    };
    timestamp: number;
};

export type ComponentSearchEvent = {
    _id: string;
    name: 'component.search.click' | 'component.search.view';
    data: {
        component: string;
        series: string | null;
        company: string;
        position: number;
        search: {
            query: string | null;
            filters: ComponentQuery;
        };
    };
    timestamp: number;
};

export type ProfileAnalyticsResponse = {
    profile: {
        views: ProfileAnalyticsEvent[];
    };
    companies: ProfileAnalyticsEvent[];
    components: ComponentSearchEvent[];
    caseStudies: ProfileAnalyticsEvent[];
};
